import { render, staticRenderFns } from "./OrderDonuts.vue?vue&type=template&id=502421a1&"
import script from "./OrderDonuts.vue?vue&type=script&lang=js&"
export * from "./OrderDonuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports